import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment-timezone'
import { getProposal } from '../../../user/actions/proposal/GetProposal'
import { clearTransaction } from '../../../user/actions/transactions/Clear'
import { sendRawTransaction } from '../../../user/actions/transactions/Voting'
import {
    Container,
    Segment,
    Header,
    Form,
    Button,
    Message,
    Modal,
    List,
    Progress,
    Grid
} from 'semantic-ui-react'
import lightwallet from 'eth-lightwallet'

class ProposalVote extends Component {

    constructor(props) {
        super(props)

        this.state = {
            showModal: false,
            checkPassword: '',
            checkConfirmPassword: '',
            proposalVote: false
        }
    }

    componentWillReceiveProps(nextProps){

        let { showHashModal  } = nextProps
  
        if(showHashModal){
 
            this.setState({ showModal: false, checkPassword:'', checkConfirmPassword:''})
        }
    }

    transactionIsDone(){

        let { dispatch, authData, params } = this.props

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()

        dispatch(clearTransaction())

        dispatch(getProposal(address[0], params.id))
    }

    checkPasswordOnInputChange(event) {
        this.setState({ checkPassword: event.target.value})
    }
	
    checkPasswordConfirmOnInputChange(event) {
        this.setState({ checkConfirmPassword: event.target.value})
    }

    proposalVoteSubmit(event) {
        event.preventDefault()

        this.setState({ showModal: true})
    }

    checkPasswordSubmitProposal(event) {
        event.preventDefault()
        
        let { checkPassword, checkConfirmPassword, proposalVote } = this.state

        let { dispatch, authData, proposalId } = this.props

        let keystore = authData.keystore
       
        dispatch(sendRawTransaction(keystore, proposalId, proposalVote, checkPassword, checkConfirmPassword))  
    }

    unixTime(unixtime) {

        return moment
            .unix(unixtime)
            .tz(moment.tz.guess())
            .format('DD/MM/YYYY HH:mm')
    }

    render() {

        let { showModal, checkPassword, checkConfirmPassword } = this.state

        let { recipient, amount, description, voteYes, voteNo, allVotes, minimumVotes, isDeadlineOver, deadline, proposalId,
            checkLoading, checkErrorMessage, checkErrorMessageText, showHashModal, transactionHash } = this.props

        return(
            <Segment style={{  minHeight: 700, paddingTop: '1em', paddingBottom: '4em' }} vertical>
                <Container>
                    <Header as='h1' style={{fontSize: '3em', fontWeight: 'normal',marginBottom: '1.5em',marginTop: '2em'}}>
                        {proposalId}. {description} {recipient === 'No recipient' ? '' : 'Recipient: '+recipient}
                    </Header>
                    <Grid stackable verticalAlign='middle' style={{paddingBottom: '2.5em'}}>
                        <Grid.Row>
                            <Grid.Column width={6}>
                                <List size='huge' relaxed style={{fontWeight: 'normal', padding:'1em', color: 'rgba(0,0,0,.68)'}}>
                                    {recipient === 'No recipient' ? '' : <List.Item icon='payment' content={amount} />}
                                    <List.Item icon='users' content={'Min '+minimumVotes+' voters'} />
                                    <List.Item icon='time' content={'Until '+this.unixTime(deadline)} />
                                </List>
                            </Grid.Column>
                            <Grid.Column width={10}>
                                <Progress size='large' value={voteYes} total={allVotes} color='green' progress='ratio' disabled={isDeadlineOver} active={!isDeadlineOver}/>
                                <Progress size='large' value={voteNo} total={allVotes} color='red' progress='ratio' disabled={isDeadlineOver} active={!isDeadlineOver}/>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column floated='right' width={6}>
                                <Form size='large' onSubmit={this.proposalVoteSubmit.bind(this)}>
                                    <Button.Group floated='right' size='large'>
                                        <Button positive type='submit' onClick={() => this.setState({proposalVote:true})}>Yes</Button><Button.Or/><Button negative onClick={() => this.setState({proposalVote:false})} type='submit'>No</Button>
                                    </Button.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Container>
                <Modal size='mini' open={showModal} closeOnEscape={!checkLoading} closeOnRootNodeClick={!checkLoading} onClose={() => this.setState({showModal:false, checkPassword:'', checkConfirmPassword:''})} closeIcon={!checkLoading}>
                    <Modal.Header>
                        Confirm your password
                    </Modal.Header>
                    <Modal.Content>
                        <Message error hidden={!checkErrorMessage} content={checkErrorMessageText}/>
                        <Form size='small' onSubmit={this.checkPasswordSubmitProposal.bind(this)} loading={checkLoading}>
                            <Form.Field>
                                <label>Password</label>
                                <input type='password' minLength='6' autoComplete='new-password' placeholder='Password' value={checkPassword} onChange={this.checkPasswordOnInputChange.bind(this)} />
                            </Form.Field>
                            <Form.Field>
                                <label>Confirm Password</label>
                                <input type='password' minLength='6' autoComplete='current-password' placeholder='Confirm Password' value={checkConfirmPassword} onChange={this.checkPasswordConfirmOnInputChange.bind(this)} />
                            </Form.Field>
                            <Button.Group size='small'>
                                <Button positive type='submit'>Submit</Button>
                            </Button.Group>
                            <p style={{fontSize: '0.7em'}}>* The transaction can take about a minute</p>
                        </Form>
                    </Modal.Content>
                </Modal>
                <Modal basic size='small' open={showHashModal} onClose={() => this.transactionIsDone()} closeIcon>
                    <Header content='Transaction Hash' />
                    <Modal.Content>
                        <p>Transaction successfully processed. <a href={'https://rinkeby.etherscan.io/tx/'+transactionHash} target="_blank">Here</a> you can find all information about it.</p>
                    </Modal.Content>
                </Modal>
            </Segment>
        )

    }
}

const mapStateToProps = (state) => {
    return {
        recipient: state.proposal.data.recipient,
        amount: state.proposal.data.amount,
        description: state.proposal.data.description,
        voteYes: state.proposal.data.voteYes,
        voteNo: state.proposal.data.voteNo,
        allVotes: state.proposal.data.allVotes,
        minimumVotes: state.proposal.data.minimumVotes,
        deadline: state.proposal.data.deadline,
        proposalId: state.proposal.data.proposalId,
        isDeadlineOver: state.proposal.data.isDeadlineOver,
        checkLoading: state.transaction.data.checkLoading,
        checkErrorMessage: state.transaction.data.checkErrorMessage,
        checkErrorMessageText: state.transaction.data.checkErrorMessageText,
        showHashModal: state.transaction.data.showHashModal, 
        transactionHash: state.transaction.data.transactionHash
    }
}

export default connect(mapStateToProps)(ProposalVote)

ProposalVote.propTypes = {
    params: PropTypes.object,
    recipient:PropTypes.string,
    amount: PropTypes.string,
    description: PropTypes.string,
    voteYes:PropTypes.string,
    voteNo:PropTypes.string,
    allVotes:PropTypes.string,
    minimumVotes:PropTypes.string,
    isDeadlineOver:PropTypes.bool,
    deadline:PropTypes.string,
    proposalId:PropTypes.string,
    authData: PropTypes.object,
    dispatch: PropTypes.func,
    checkLoading: PropTypes.bool,
    checkErrorMessage: PropTypes.bool,
    checkErrorMessageText: PropTypes.string,
    showHashModal: PropTypes.bool, 
    transactionHash: PropTypes.string
}


// WEBPACK FOOTER //
// ./src/layouts/proposal/components/ProposalVote.js